export default __webpack_public_path__ + "static/media/genius_icon.494179d2.svg";